"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRemindLaterCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
function createRemindLaterCard(surveyId, threadId, messageId) {
    const card = CardHelper_1.CardHelper.newCard();
    const columns = new adaptivecards_1.ColumnSet();
    const leftcol = CardHelper_1.CardHelper.create(adaptivecards_1.Column, {
        width: "auto",
        verticalContentAlignment: adaptivecards_1.VerticalAlignment.Center,
    });
    const rightCol = new adaptivecards_1.Column();
    leftcol.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "Remind Me In:",
    }));
    rightCol.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.ChoiceSetInput, {
        isCompact: true,
        isMultiSelect: false,
        id: "interval",
        choices: [
            CardHelper_1.CardHelper.create(adaptivecards_1.Choice, { value: "PT1M", title: "1 Minute" }),
            CardHelper_1.CardHelper.create(adaptivecards_1.Choice, { value: "PT1H", title: "1 Hour" }),
            CardHelper_1.CardHelper.create(adaptivecards_1.Choice, { value: "PT2H", title: "2 Hours" }),
            CardHelper_1.CardHelper.create(adaptivecards_1.Choice, { value: "P1D", title: "1 Day" }),
        ],
    }));
    columns.addColumn(leftcol);
    columns.addColumn(rightCol);
    card.addItem(columns);
    card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
        title: "Set Reminder",
        data: (0, commands_1.takingReminderSetCommand)(surveyId, threadId, messageId).toInvokeCommand(),
    }));
    return card;
}
exports.createRemindLaterCard = createRemindLaterCard;
//# sourceMappingURL=RemindLater.js.map